import React from 'react';
import { cn } from '@/lib/twUtils';

const sizes = {
  /** H1 di homepage */
  hero: 'text-[clamp(2.375rem,6vw,4.25rem)] leading-[1.03] tracking-[-0.035em]',
  /** H1 di pagina interna */
  page: 'text-[clamp(2.125rem,5vw,3.5rem)] leading-[1.06] tracking-[-0.035em]',
  /** H2 principale */
  xl: 'text-[clamp(1.875rem,4.4vw,3.125rem)] leading-[1.08] tracking-[-0.03em]',
  /** H2 standard */
  lg: 'text-[clamp(1.6875rem,3.6vw,2.625rem)] leading-[1.12] tracking-[-0.03em]',
  /** H2 minore, H3 in evidenza */
  md: 'text-[clamp(1.4375rem,2.9vw,2rem)] leading-[1.18] tracking-[-0.025em]',
  /** Titolo di card grande */
  sm: 'text-[clamp(1.25rem,2.2vw,1.5rem)] leading-[1.22] tracking-[-0.02em]',
  /** Titolo di card compatta */
  xs: 'text-[1.0625rem] leading-[1.3] tracking-[-0.01em]',
} as const;

const tones = {
  ink: 'text-primary',
  light: 'text-white',
  muted: 'text-ink-muted',
} as const;

export interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'p' | 'div';
  size?: keyof typeof sizes;
  tone?: keyof typeof tones;
  /** Bilancia le righe: da usare sui titoli brevi, non sui paragrafi */
  balance?: boolean;
}

/** Titolo del design system: Sora, tracking stretto, scala fluida. */
const Heading = ({
  as: Tag = 'h2',
  size = 'lg',
  tone = 'ink',
  balance = true,
  className,
  ...props
}: HeadingProps) => (
  <Tag
    className={cn(
      'font-display font-semibold',
      sizes[size],
      tones[tone],
      balance && 'text-balance',
      className
    )}
    {...props}
  />
);

export default Heading;
